<template>
    <div>
        <div class="action-header">
            <div class="search-container">
                <div class="search-input">
                    <v-text-field
                        v-model="search"
                        prepend-inner-icon="search"
                        :placeholder="$vuetify.lang.t('$vuetify.specialWorkday.searchBy')"
                        solo
                        height="40px"
                        @keyup.enter="getSpecialWorkdaysPagination()">
                    </v-text-field>
                </div>

                <div class="ml-3">
                    <v-btn
                        @click="searchSpecialWorkdays()"
                        height="40px"
                        color="primary"
                        outlined>
                        {{ $vuetify.lang.t('$vuetify.specialWorkday.search') }}
                    </v-btn>
                </div>
            </div>
            <div>
                <v-btn
                    v-if="permissionCreate"
                    height="40px"
                    @click="addSpecialWorkdayModal()"
                    color="primary"
                    :disabled="!branch">
                    + {{ $vuetify.lang.t('$vuetify.specialWorkday.addSpecialWorkday') }}
                </v-btn>
            </div>
        </div>
        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                @page-count="pageCount = $event"
                :page.sync="page"
                :headers="headers"
                :options.sync="options"
                :server-items-length="totalSpecialWorkday"
                :items="specialWorkdays"
                :loading="loading">
                <template
                    v-if="permissionUpdate || permissionDelete"
                    v-slot:[`item.action`]="{ item }">
                    <div class="action">
                        <v-icon
                            v-if="permissionUpdate && passedDate(item)"
                            class="mr-2"
                            @click="updateSpecialWorkday(item)">
                            edit
                        </v-icon>
                        <v-icon
                            v-if="permissionDelete && passedDate(item)"
                            class="mr-2"
                            @click="openModalDelete(item)">
                            delete
                        </v-icon>
                    </div>
                </template>
            </v-data-table>
        </v-card>

        <div class="pt-2 paginator-box">
            <div>
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </div>

        <special-workday-form-modal
            ref="specialWorkDayFormModal"
            :mode="operationMode"
            :branchId="branch"
            :specialWorkdayId="updateSpecialWorkdayId"
            :min="minDate"
            @modal-closed="specialWorkdayModalIsClosed()"
            @success="getSpecialWorkdaysPagination()">
        </special-workday-form-modal>

        <delete-modal
            ref="modalDelete"
            @success-deleted="deleteSuccess()"
            :deleteForm="deleteForm"/>
    </div>
</template>

<script>
import SpecialWorkdayFormModal from '@/components/modal/SpecialWorkdayFormModal'
import DeleteModal from '@/components/modal/DeleteModal'
import permissionConstant from '@/constants/permissions.js'

export default {
    name: 'SpecialWorkday',

    components: {
        SpecialWorkdayFormModal,
        DeleteModal
    },
    computed: {
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.specialWorkday.specialWorkdayName'), value: 'name', width: '12%' },
                { text: this.$vuetify.lang.t('$vuetify.specialWorkday.workDay'), value: 'date', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.specialWorkday.dateCreate'), value: 'created_at', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.specialWorkday.startEndTime'), value: 'full_time', width: '18%' },
                { text: this.$vuetify.lang.t('$vuetify.specialWorkday.description'), value: 'description', width: '20%' },
                { text: this.$vuetify.lang.t('$vuetify.specialWorkday.forGroup'), value: 'for_group', width: '12%' },
                { text: '', value: 'action', width: '8%', sortable: false }
            ]
        },
        questionDelete () {
            return this.$vuetify.lang.t('$vuetify.specialWorkday.questionDelete')
        },
        msgDeleteSuccess () {
            return {
                title: this.$vuetify.lang.t('$vuetify.specialWorkday.congratulation'),
                text: this.$vuetify.lang.t('$vuetify.specialWorkday.msgDeleteSuccess'),
                type: 'success'
            }
        }
    },
    data () {
        return {
            search: '',
            specialWorkdays: [],
            updateSpecialWorkdayId: null,
            operationMode: '',
            minDate: null,
            pageCount: 1,
            page: 1,
            options: {},
            specialWorkday: [],
            totalSpecialWorkday: 0,
            loading: false,
            branch: null,
            permissionCreate: true,
            permissionUpdate: true,
            permissionDelete: true,
            deleteForm: {
                header: '',
                content: '',
                path: ''
            }
        }
    },
    methods: {
        updateSpecialWorkday (specialWorkday) {
            this.operationMode = 'update'
            this.updateSpecialWorkdayId = specialWorkday.id
            this.$refs.specialWorkDayFormModal.dialog = true
        },

        openModalDelete (specialWorkday) {
            this.deleteForm.header = this.$vuetify.lang.t('$vuetify.specialWorkday.deleteGroup')
            this.deleteForm.content = this.questionDelete.replace('$Name', specialWorkday.name)
            this.deleteForm.path = `specialworkday/delete/${specialWorkday.id}`
            this.$refs.modalDelete.dialog = true
        },

        addSpecialWorkdayModal () {
            this.operationMode = 'create'
            this.$refs.specialWorkDayFormModal.dialog = true
        },

        specialWorkdayModalIsClosed () {
            this.operationMode = null
            this.updateSpecialWorkdayId = null
        },

        setMinDate () {
            const now = new Date()
            const nextDate = now.setDate(now.getDate() + 1)
            return new Date(nextDate).toISOString().substr(0, 10)
        },

        async searchSpecialWorkdays () {
            this.options.page = 1
            await this.getSpecialWorkdaysPagination()
        },

        async getSpecialWorkdaysPagination () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `specialworkdays?branch=${this.branch}&page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.specialWorkdays = res.data.data
                this.totalSpecialWorkday = res.data.total
                this.loading = false
            }
        },

        async getBranch () {
            this.branch = parseInt(localStorage.getItem('currentBranchId'))
            if (this.branch) {
                await this.getSpecialWorkdaysPagination()
            }
        },

        async deleteSuccess () {
            this.$notify(this.msgDeleteSuccess)
            await this.getSpecialWorkdaysPagination()
        },

        checkPermission () {
            this.permissionCreate = this.$util.checkPermission(permissionConstant.specialWorkday.create)
            this.permissionUpdate = this.$util.checkPermission(permissionConstant.specialWorkday.update)
            this.permissionDelete = this.$util.checkPermission(permissionConstant.specialWorkday.delete)
        },

        passedDate (item) {
            const dateObj = this.$util.dateStringToDateObj(item.date)
            const now = new Date()

            if (now.getTime() > dateObj.getTime()) {
                return false
            }
            return true
        }
    },
    async mounted () {
        this.$store.dispatch('setLoading', true)
        this.minDate = this.setMinDate()
        await this.getBranch()
        this.checkPermission()
        this.$store.dispatch('setLoading', false)
    },

    watch: {
        options: {
            async handler () {
                if (this.branch) {
                    await this.getSpecialWorkdaysPagination()
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-input__control > .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
    box-shadow: none !important;
    border: 1px solid #a8a8a8 !important;
}

.header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2rem;
    font-size: 28px;
    font-weight: bold;
}

.sub-header {
    padding: 16px;
    display: flex;
    justify-content: flex-end;
}

.search{
    width: 0;
}
</style>
